<template>
	<div class="home">
		<!-- 使用公共组件，传入对应的属性 -->
		<CommonTablePage 
			:type="type"
			:titleValue="titleValue" 
			placeholder="请输入中文名称/英文名称/CAS号" 
			:columns="columns" 
			:apiType="apiType" 
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import CommonTablePage from "./components/CommonTablePage.vue";

defineOptions({
	name: "InterRefMed"
});

const props = defineProps({
	type: {
		type: String,
		default: ""
	}
});

// 计算标题，保持原有逻辑
const titleValue = computed(() => {
	switch (props.type) {
		case "ref":
			return "对照品";
		case "inter":
			return "化药中间体";
		default:
			return "对照品";
	}
});

// 根据 type 确定传给公共组件的 apiType，保持原有 fetchData 中的判断逻辑
const apiType = computed(() => {
	return props.type === "ref" ? "reference_standard" : "intermediate";
});

// 定义表格列配置，保持与原 interRefMed 表格一致
const columns = [
	{
		prop: "chineseName",
		label: "中文名称"
	},
	{
		prop: "englishName",
		label: "英文名称"
	},
	{
		prop: "casNumber",
		label: "CAS号"
	}
];
</script>

<style lang="styl" scoped>
.home {
  width: 100%;
  min-height: calc(100% - 90px);
  background-color: #fff;
}
</style>